// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"5q2jT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _landingPageView = require("../views/landingLoginPage/landingPageView");
var _landingPageViewDefault = parcelHelpers.interopDefault(_landingPageView);
var _loginView = require("../views/landingLoginPage/loginView");
var _loginViewDefault = parcelHelpers.interopDefault(_loginView);
var _homePageView = require("../views/homepage/homePageView");
var _homePageViewDefault = parcelHelpers.interopDefault(_homePageView);
var _model = require("../model");
class landingLoginPageController {
    init() {
        (0, _landingPageViewDefault.default).generateText();
        (0, _landingPageViewDefault.default).addButtonEvent();
        (0, _loginViewDefault.default).createInputAnimation();
        (0, _loginViewDefault.default).addCrossEvent();
        (0, _loginViewDefault.default).addHandlerLogin(this.#controlValidate);
        (0, _loginViewDefault.default).addHandlerSignUp(this.#controlRegister);
        (0, _loginViewDefault.default).addGoToSignUpEvent();
        (0, _loginViewDefault.default).addSelectEvent();
    }
    #controlValidate = async function() {
        try {
            const formData = (0, _loginViewDefault.default).getFormData();
            await _model.validateLogin(formData);
            console.log(_model.state.token);
            localStorage.setItem("token", JSON.stringify(_model.state.token));
            (0, _loginViewDefault.default).goToMainPage();
        } catch (err) {
            (0, _loginViewDefault.default).renderMessageLogin("Invalid Username or Password");
        }
    };
    #controlRegister = async function() {
        try {
            const formData = (0, _loginViewDefault.default).getSignUpData();
            console.log(formData);
            _model.validatePassword(formData.password, formData.confirmation);
            _model.validateUsername(formData.username);
            _model.validateCountry(formData.country);
            await _model.registerUser(formData);
            localStorage.setItem("token", JSON.stringify(_model.state.token));
            (0, _loginViewDefault.default).goToMainPage();
        } catch (err) {
            (0, _loginViewDefault.default).renderMessageSignUp(err.message);
        }
    };
}
const controller = new landingLoginPageController();
controller.init();

},{"../views/landingLoginPage/landingPageView":"7AcjZ","../views/landingLoginPage/loginView":"8hOqg","../views/homepage/homePageView":"6dGDp","../model":"6PfyX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7AcjZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class LandingPageView {
    #textEl = document.querySelector("h2");
    #button = document.querySelector(".start-button");
    #login = document.querySelector(".login-modal");
    #signup = document.querySelector(".signup-modal");
    #text = "Medical knowledge. No downloads. Fun.";
    #letterIndex = 1;
    #intervalId = null;
    generateText() {
        this.#intervalId = setInterval(this.#appendLetter.bind(this), 90);
    }
    #appendLetter() {
        this.#textEl.innerText = this.#text.slice(0, this.#letterIndex);
        this.#letterIndex++;
        if (this.#letterIndex > this.#text.length) clearInterval(this.#intervalId);
    }
    addButtonEvent() {
        this.#button.addEventListener("click", ()=>{
            this.#signup.classList.toggle("hidden");
        });
    }
}
exports.default = new LandingPageView();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8hOqg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class LoginModalView {
    #labels = document.querySelectorAll("label");
    #svgs = document.querySelectorAll(".cross");
    #loginFormEl = document.querySelector(".login-form");
    #signUpFormEl = document.querySelector(".signup-form");
    #usernameEl = document.getElementById("username");
    #passwordEl = document.getElementById("password");
    #signupSpanEl = document.querySelector(".signup-span");
    #selectEl = document.querySelector(".select-country");
    #usernameSignupEl = document.getElementById("username-signup");
    #passwordSignupEl = document.getElementById("password-signup");
    #confirmationEl = document.getElementById("password-confirmation");
    #codeEl = document.getElementById("code");
    #formControlPasswordEl = document.querySelector(".form-control-password");
    #formControlCodeEl = document.querySelector(".form-control-code");
    createInputAnimation() {
        this.#labels.forEach((label)=>{
            label.innerHTML = label.innerText.split("").map((letter, i)=>{
                return `<span style="transition-delay:${i * 50}ms">${letter}</span>`;
            }).join("");
        });
    }
    addCrossEvent() {
        this.#svgs.forEach((svg)=>{
            svg.addEventListener("click", (e)=>{
                e.target.closest(".modal").classList.toggle("hidden");
            });
        });
    }
    addGoToSignUpEvent() {
        this.#signupSpanEl.addEventListener("click", ()=>{
            document.querySelector(".login-modal").classList.toggle("hidden");
            document.querySelector(".signup-modal").classList.toggle("hidden");
        });
    }
    addSelectEvent() {
        this.#selectEl.addEventListener("change", ()=>{
            if (this.#selectEl.value !== "0") {
                this.#selectEl.classList.remove("default");
                return;
            }
            this.#selectEl.classList.add("default");
        });
    }
    addHandlerLogin(handler) {
        this.#loginFormEl.addEventListener("submit", (ev)=>{
            ev.preventDefault();
            handler();
        });
    }
    addHandlerSignUp(handler) {
        this.#signUpFormEl.addEventListener("submit", (ev)=>{
            ev.preventDefault();
            handler();
        });
    }
    getFormData() {
        const username = this.#usernameEl.value;
        const password = this.#passwordEl.value;
        return {
            username,
            password
        };
    }
    getSignUpData() {
        const username = this.#usernameSignupEl.value;
        const password = this.#passwordSignupEl.value;
        const confirmation = this.#confirmationEl.value;
        const country = this.#selectEl.value;
        const code = this.#codeEl.value;
        return {
            username,
            password,
            confirmation,
            country,
            code
        };
    }
    goToMainPage() {
        window.location.href = "../../homePage.html";
    }
    renderMessageLogin(message) {
        const markup = `<div class="error login">${message}</div>`;
        this.#formControlPasswordEl.insertAdjacentHTML("beforeend", markup);
    }
    renderMessageSignUp(message) {
        const markup = `<div class="error login">${message}</div>`;
        const lastChild = this.#formControlCodeEl.lastElementChild;
        if (lastChild.classList.contains("error")) lastChild.remove();
        this.#formControlCodeEl.insertAdjacentHTML("beforeend", markup);
    }
}
exports.default = new LoginModalView();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6dGDp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dist = require("country-flags-svg/dist");
class HomePageView {
    #buttonLearn = document.querySelector(".learn-button");
    #rankListEl = document.querySelector(".rank-list");
    #countdownSpanEl = document.querySelector(".countdown-span");
    renderWelcomeMessage(data) {
        const containerEl = document.querySelector(".welcome-container");
        const markup = `<h1>Welcome back, ${data.username}</h1>`;
        console.log(markup);
        console.log(containerEl);
        containerEl.insertAdjacentHTML("afterbegin", markup);
    }
    renderRank(rank) {
        console.log(rank);
        rank.forEach((userData)=>{
            console.log((0, _dist.findFlagUrlByIso3Code)(userData.country));
            const markup = `<li>
                  <div class="person">
                    <p class="position">${userData.position}</p>
                    <!--
                    <object
                      type="image/svg+xml"
                      data="${(0, _dist.findFlagUrlByIso3Code)(userData.country)}"
                      class=""
                    >
                      Your browser does not support SVG
                    </object>
                    -->
                    <p class="name">${userData.userName}</p>
                    <p class="exp">${userData.points} xp</p>
                  </div>
                </li>`;
            this.#rankListEl.insertAdjacentHTML("beforeend", markup);
        });
        console.log(this.#rankListEl);
    }
    renderUserRank(userRank) {
        const markup = `<div class="dots">
    <button class="dot" id="dot-2"></button>
    <button class="dot" id="dot-2"></button>
    <button class="dot" id="dot-2"></button>
    </div><li class="user"> 
      <div class="person">
        <p class="position">${userRank.position ? userRank.position : "-"}</p>
        <!--
        <object
          type="image/svg+xml"
          data="${(0, _dist.findFlagUrlByIso3Code)(userRank.country)}"
          class=""
        >
          Your browser does not support SVG
        </object>
        -->
        <p class="name">${userRank.userName}</p>
        <p class="exp">${userRank.points} xp</p>
      </div>
    </li>`;
        this.#rankListEl.insertAdjacentHTML("beforeend", markup);
    }
    colorUserRankBackground(position) {
        console.log(this.#rankListEl.querySelectorAll("li")[position - 1].classList.add("user"));
    }
    addButtonLearnEvent() {
        console.log(this.#buttonLearn);
        console.log(this);
        this.#buttonLearn.addEventListener("click", ()=>{
            window.location.href = "../../questions.html";
        });
    }
    setCountdown() {
        this.#renderCountdown();
        setInterval(this.#renderCountdown.bind(this), 1000);
    }
    #renderCountdown() {
        let time = this.#calculateTime();
        this.#countdownSpanEl.innerText = time;
    }
    #calculateTime() {
        let d = new Date();
        let hours = 23 - d.getUTCHours();
        let min = 59 - d.getMinutes();
        if ((min + "").length == 1) min = "0" + min;
        let sec = 59 - d.getSeconds();
        if ((sec + "").length == 1) sec = "0" + sec;
        return hours + ":" + min + ":" + sec;
    }
}
exports.default = new HomePageView();

},{"country-flags-svg/dist":"kDita","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6PfyX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "state", ()=>state);
parcelHelpers.export(exports, "validateLogin", ()=>validateLogin);
parcelHelpers.export(exports, "getLoggedUser", ()=>getLoggedUser);
parcelHelpers.export(exports, "getCurrrentList", ()=>getCurrrentList);
parcelHelpers.export(exports, "processAnswer", ()=>processAnswer);
parcelHelpers.export(exports, "allExerciseDone", ()=>allExerciseDone);
parcelHelpers.export(exports, "postUserAnswers", ()=>postUserAnswers);
parcelHelpers.export(exports, "getWeekRank", ()=>getWeekRank);
parcelHelpers.export(exports, "getUserWeekRank", ()=>getUserWeekRank);
parcelHelpers.export(exports, "isUserinTop10", ()=>isUserinTop10);
parcelHelpers.export(exports, "UserAlreadyDoneList", ()=>UserAlreadyDoneList);
parcelHelpers.export(exports, "getUserAnswersByUserAndList", ()=>getUserAnswersByUserAndList);
parcelHelpers.export(exports, "validatePassword", ()=>validatePassword);
parcelHelpers.export(exports, "validateUsername", ()=>validateUsername);
parcelHelpers.export(exports, "validateCountry", ()=>validateCountry);
parcelHelpers.export(exports, "registerUser", ()=>registerUser);
var _config = require("./config");
const state = {
    user: {},
    token: "",
    currentList: "",
    userAnswers: [],
    weekRank: [],
    userRank: {}
};
const validateLogin = async function(data) {
    try {
        const response = await fetch(`${(0, _config.API_URL_AUTH_PROD)}authenticate`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
        if (!response.ok) {
            const result = await response.json();
            throw new Error(result.message);
        }
        console.log(response);
        const result = await response.json();
        console.log(result);
        state.token = result.token;
    } catch (err) {
        throw err;
    }
};
const getLoggedUser = async function() {
    try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${(0, _config.API_URL_PROD)}user/logged`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) {
            const result = await response.json();
            throw new Error(result.message);
        }
        const result = await response.json();
        const user = result;
        state.user = {
            id: user.id,
            firstname: user.firstname,
            lastname: user.lastname,
            username: user.username,
            country: user.country
        };
    } catch (err) {
        throw err;
    }
};
const getCurrrentList = async function() {
    try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${(0, _config.API_URL_PROD)}exerciseList/currentList`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) {
            const result = await response.json();
            throw new Error(result.message);
        }
        const result = await response.json();
        state.currentList = result;
    } catch (err) {
        throw err;
    }
};
const processAnswer = function(exerciseId, status) {
    if (exerciseId == undefined || status == undefined) return;
    let userAnswer = state.userAnswers.find((userAnswer)=>{
        return userAnswer.exerciseId === exerciseId;
    });
    // if there is already an answers of this exercise on the userAnswers list
    if (userAnswer) {
        if (status === "correct") {
            userAnswer.userResponseStatusId = 1;
            console.log(state.userAnswers);
            return;
        }
        userAnswer.userResponseStatusId = 2;
        userAnswer.errors++;
        console.log(state.userAnswers);
        return;
    }
    // when the answer is not on the userAnswers list yet
    let userResponseStatusId;
    let errors;
    if (status === "correct") {
        errors = 0;
        userResponseStatusId = 1;
    } else {
        errors = 1;
        userResponseStatusId = 2;
    }
    userAnswer = {
        exerciseId: exerciseId,
        userId: state.user.id,
        userResponseStatusId: userResponseStatusId,
        errors: errors
    };
    state.userAnswers.push(userAnswer);
    console.log(state.userAnswers);
};
const allExerciseDone = function() {
    return state.userAnswers.length === state.currentList.exercises.length && !state.userAnswers.find((userAnswer)=>{
        return userAnswer.userResponseStatusId == 2;
    });
};
const postUserAnswers = async function(userAnswers) {
    try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${(0, _config.API_URL_PROD)}userAnswer/sendAll`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(userAnswers)
        });
        if (!response.ok) {
            const result = await response.json();
            throw new Error(result.message);
        }
        console.log(response);
        const result = await response.json();
        console.log(result);
    } catch (err) {
        throw err;
    }
};
const getWeekRank = async function() {
    try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${(0, _config.API_URL_PROD)}userAnswer/weekRank`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) {
            const result = await response.json();
            throw new Error(result.message);
        }
        const result = await response.json();
        state.weekRank = result;
        console.log(state.weekRank);
    } catch (err) {
        throw err;
    }
};
const getUserWeekRank = async function() {
    try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${(0, _config.API_URL_PROD)}userAnswer/userRank`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response);
        if (!response.ok) {
            const result = await response.json();
            console.log(result);
            throw new Error(result.message);
        }
        const result = await response.json();
        state.userRank = result;
        console.log(state.userRank);
    } catch (err) {
        throw err;
    }
};
const isUserinTop10 = function() {
    return state.userRank.position !== null && state.userRank.position <= 10;
};
const UserAlreadyDoneList = async function(exerciseListId) {
    try {
        const list = await getUserAnswersByUserAndList(exerciseListId);
        if (list.length > 0) return true;
        return false;
    } catch (err) {
        throw err;
    }
};
const getUserAnswersByUserAndList = async function(exerciseListId) {
    try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${(0, _config.API_URL_PROD)}userAnswer/${exerciseListId}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response);
        if (!response.ok) {
            const result = await response.json();
            console.log(result);
            throw new Error(result.message);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        throw err;
    }
};
const validatePassword = function(password, confirmation) {
    try {
        if (password.length < 8) throw new Error("8 characters minimum per paswword");
        if (password !== confirmation) throw new Error("Please confirm your password");
    } catch (err) {
        throw err;
    }
};
const validateUsername = function(username) {
    try {
        if (username.length <= 5) throw new Error("6 characters minimum per username");
        if (username.length >= 15) throw new Error("15 characters maximum per username");
    } catch (err) {
        throw err;
    }
};
const validateCountry = function(country) {
    try {
        if (country === "0") throw new Error("Please select a country");
    } catch (err) {
        throw err;
    }
};
const registerUser = async function(data) {
    try {
        const response = await fetch(`${(0, _config.API_URL_AUTH_PROD)}register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
        console.log(response);
        if (!response.ok) {
            const result = await response.json();
            console.log(result);
            throw new Error(result.message);
        }
        console.log(response);
        const result = await response.json();
        console.log(result);
        state.token = result.token;
    } catch (err) {
        throw err;
    }
};

},{"./config":"jV0d1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}]},["5q2jT"], "5q2jT", "parcelRequire276b")

//# sourceMappingURL=index.7cb5554c.js.map
